import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import { Translator } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "test"
    }}>{`TEST`}</h1>
    <Playground __position={0} __code={'<button>TEST</button>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Translator
    }} mdxType="Playground">
  <button>TEST</button>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      